<template>
  <div v-if="hasExcursion" :class="[containerClass, tabbed ? 'tabbed-container' : '']" class="overflow-hidden">
    <!-- Header -->
    <div v-if="!tabbed" :class="[colorClass + '--background', 'text-center', 'renedian-sand--text', 'barlow-condensed-bold', 'pa-4']" class="font-size-lg line-height-4">
      {{ excursionDuration }}-DAY PRE-TRIP EXCURSION OPTION
    </div>
    
    <div class="white renedian-sand--background">
      <div class="d-flex flex-column white justify-center align-center">
        <!-- Price Section -->
        <div class="rider-price-container d-flex flex-row justify-center pa-6 mt-6">
          <div class="d-flex flex-column flex-md-row justify-center align-center">
            <div class="d-flex flex-column">
              <div class="barlow-condensed-regular text-uppercase font-size-lg line-height-4">{{ year }} Price</div>
              <div class="barlow-regular d-none d-md-block text-right text-uppercase font-size-xs">From</div>
            </div>
            <div class="d-flex flex-row align-center">
              <div class="d-block d-md-none barlow-regular text-right text-uppercase font-size-sm">From</div>
              <div :class="['ml-4', 'barlow-condensed-semibold', colorClass + '--text']" class="font-size-huge">
                {{ excursionPricing?.base | price }}
              </div>
              <div class="d-flex ml-2" style="height: 3rem; align-items: flex-end;">
                {{ currency }}
              </div>
            </div>
          </div>
        </div>

        <!-- Includes Section -->
        <div class="d-flex flex-column flex-md-row align-center justify-center px-4">
          <div :class="['barlow-bold', 'text-uppercase', colorClass + '--text', 'mr-4']" class="font-size-xs">Includes</div>
          <div class="d-flex flex-column">
            <div class="d-flex flex-row align-center mb-2">
              <v-icon size="20" class="mr-2">{{ hasSupportVehicle ? 'mdi-van-passenger' : 'mdi-motorbike' }}</v-icon>
              <div class="barlow-regular text-uppercase">
                {{ hasSupportVehicle ? 'Passenger in support van' : 'Passenger on bike' }}
              </div>
            </div>
            <div class="d-flex flex-row align-center">
              <v-icon size="20" class="mr-2">mdi-bed</v-icon>
              <div class="barlow-regular text-uppercase">Shared accommodations</div>
            </div>
          </div>
        </div>

        <!-- Color Divider -->
        <div :class="[colorClass + '--background', 'mt-12', 'width-100']" style="height: 2px;"></div>
        <!-- Accommodation Options Heading -->
        <div :class="['barlow-condensed-regular', 'text-uppercase', 'mb-2', 'text-center', colorClass + '--text']" style="font-size: 1.5rem; margin-top: 5px">Accommodation Options</div>
        <!-- Color Divider -->
        <div :class="[colorClass + '--background', 'mb-12', 'width-100']" style="height: 2px;"></div>

        <!-- Accommodation Option Section -->
        <div class="d-flex flex-column align-center" style="width: 100%;">
          <div class="d-flex flex-row align-center">
            <v-icon size="20" class="mr-2">mdi-bed</v-icon>
            <div class="barlow-regular text-uppercase">Single Room</div>
            <div :class="['ml-4', 'barlow-bold-italic', colorClass + '--text']">
              +{{ excursionPricing?.solo | price }} {{ currency }}
            </div>
          </div>
        </div>

        <!-- Color Divider -->
        <div :class="[colorClass + '--background', 'mt-12', 'width-100']" style="height: 2px;"></div>
        <!-- Excursion Details Heading -->
        <div :class="['barlow-condensed-regular', 'text-uppercase', 'mb-2', 'text-center', colorClass + '--text']" style="font-size: 1.5rem; margin-top: 5px">Excursion Details</div>
        <!-- Color Divider -->
        <div :class="[colorClass + '--background', 'mb-12', 'width-100']" style="height: 2px;"></div>

        <!-- Excursion Details Section -->
        <div class="d-flex flex-column align-center mb-12" style="width: 100%;">
          <!-- Logo -->
          <div v-if="excursionBadgeImage" class="mb-6">
            <img :src="$img(excursionBadgeImage, 400)" alt="Excursion Logo" loading="lazy" style="width: 200px; height: 200px; object-fit: cover; border: 3px solid white;" />
          </div>

          <!-- Description -->
          <div v-if="excursionDescription" class="barlow-regular text-center mb-6 px-4" style="font-size: 1rem; line-height: 1.6em; max-width: 600px;">
            {{ excursionDescription }}
          </div>

          <!-- Learn More Button -->
          <div 
            :class="['cursor-pointer', colorClass + '--learn-more-button', 'barlow-bold', 'text-uppercase', colorClass + '--text', 'cursor-pointer', 'pa-4']"
            @click="scrollToItinerary"
          >
            LEARN MORE
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TourDetailsExcursion',
  props: {
    year: {
      type: Number,
      required: true
    },
    color: {
      type: String,
      required: true
    },
    template: {
      type: Object,
      required: true
    },
    tour: {
      type: Object,
      required: true
    },
    tabbed: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    colorClass() {
      return this.color
    },
    containerClass() {
      if (this.color === 'renedian-burnt-orange') {
        return 'current-year-container'
      } else if (this.color === 'renedian-sand-grey') {
        return 'next-year-container'
      }
      return ''
    },
    // Pricing comes only from the tour — never template or pricing.excursion.
    excursionPricing() {
      return this.tour?.excursion?.pricing || null
    },
    hasSupportVehicle() {
      return this.template?.riding?.supportVehicle || false
    },
    currency() {
      return this.excursionPricing?.currency || this.tour?.pricing?.currency || 'CAD'
    },
    hasExcursion() {
      if (!this.tour?.excursion?.available) return false
      const base = this.excursionPricing?.base
      if (base === undefined || base === null) return false
      const n = typeof base === 'number' ? base : parseFloat(String(base).replace(/,/g, ''))
      return Number.isFinite(n)
    },
    excursionDuration() {
      return this.tour?.excursion?.duration ||
        this.tour?.excursion?.general?.duration ||
        this.template?.excursion?.duration ||
        this.template?.excursion?.general?.duration ||
        3
    },
    excursionBadgeImage() {
      const badge = this.tour?.excursion?.images?.badge || this.template?.excursion?.images?.badge
      if (!badge) return null
      if (typeof badge === 'string') return badge
      if (typeof badge === 'object') return badge.url || badge.src || null
      return null
    },
    excursionDescription() {
      const desc = this.tour?.excursion?.description || this.template?.excursion?.description
      if (!desc) return null
      return desc.public || desc.general || desc.detailed || null
    },
  },
  methods: {
    scrollToItinerary() {
      // Emit event to parent to scroll to itinerary section
      this.$emit('scroll-to-itinerary')
      
      // Also try to scroll directly using the same approach as Tour.vue
      this.$nextTick(() => {
        const itinerarySection = document.getElementById('itinerary') || this.$parent?.$refs?.itinerary
        if (itinerarySection) {
          const headerOffset = 80 // Approximate header height
          const y = itinerarySection.getBoundingClientRect().top + window.pageYOffset - headerOffset
          window.scrollTo({ top: y, behavior: 'smooth' })
        }
      })
    }
  },
  filters: {
    price(price) {
      if (price === undefined || price === null || isNaN(Number(price))) return price
      return '$' + Number(price).toLocaleString()
    }
  }
}
</script>

<style scoped>
.current-year-container {
  border: 2px solid #b35438;
  border-radius: 30px;
}
.next-year-container {
  border: 2px solid #5a6660;
  border-radius: 30px;
}
.renedian-burnt-orange--learn-more-button {
  border: 2px dashed #b35438;
  border-radius: 4px;
  min-width: 200px;
  text-align: center;
  transition: opacity 0.2s;
}
.renedian-sand-grey--learn-more-button {
  border: 2px dashed #5a6660;
  border-radius: 4px;
  min-width: 200px;
  text-align: center;
  transition: opacity 0.2s;
}

.tabbed-container {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}
</style>